import axios from 'axios';
import { useCallback } from 'react';

import { configSetting } from '../../../config';

// Raw calls for the sign-in passkey steps. They carry a ticket (or a
// recovery-only token) instead of the dashboard session, so they bypass the
// auth and 401-refresh interceptors: a 401 here must never log anyone out.
const usePasskeyApi = () =>
  useCallback(async <T,>(path: string, data?: any, token?: string): Promise<T> => {
    try {
      const response = await axios.post(`${configSetting.apiUrl}${path}`, data ?? {}, {
        headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        skipAuth: true,
        skipLogoutRedirect: true,
      } as any);
      return response.data.data as T;
    } catch (err: any) {
      const message = err?.response?.data?.message;
      throw new Error(typeof message === 'string' ? message : 'Something went wrong');
    }
  }, []);

export default usePasskeyApi;
